module.exports = __webpack_public_path__ + "static/media/ProximaNova-Semibold.474a2cb3.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova-Semibold.eot
// module id = 3538
// module chunks = 70